module.exports = __webpack_public_path__ + "img/home_city.9901eaea.jpg";